<template>
  <div
    class="ds-control mobile dsf-teas-student-class"
    :class="{ 'ds-no-padding': !isDesign }"
  >
    <template v-if="classDataList.length">
      <template v-if="nowClassLisst.length">
        <div class="dsf-teas-student-class-sort-title">当前班次</div>
        <slot :info="nowClassLisst[0]">
          <div
            class="dsf-teas-student-class-item"
            @click="classItemClick(nowClassLisst[0])"
          >
            <div class="status">
              <div
                class="type pass"
                v-if="nowClassLisst[0].statusValue == 2"
              >
                {{ nowClassLisst[0].statusText }}
              </div>
              <div
                class="type auditing"
                v-else-if="nowClassLisst[0].statusValue == 1"
              >
                {{ nowClassLisst[0].statusText }}
              </div>
              <div class="type nopass" v-else>
                {{ nowClassLisst[0].statusText }}
              </div>
            </div>
            <div class="dsf-teas-student-class-name">
              {{ nowClassLisst[0].className }}
            </div>
            <div class="dsf-teas-student-class-row">
              <DsfIcon class="dsf-teas-student-class-icon"></DsfIcon>
              <div class="dsf-teas-student-class-label">学号：</div>
              <div class="dsf-teas-student-class-value">
                {{ nowClassLisst[0].studentSerialNumber }}
              </div>
            </div>
            <div class="dsf-teas-student-class-row">
              <DsfIcon class="dsf-teas-student-class-icon"></DsfIcon>
              <div class="dsf-teas-student-class-label">班主任：</div>
              <div class="dsf-teas-student-class-value">
                {{ nowClassLisst[0].teacherClasses }}
              </div>
            </div>
            <div class="dsf-teas-student-class-row">
              <DsfIcon class="dsf-teas-student-class-icon"></DsfIcon>
              <div class="dsf-teas-student-class-label">培训日期：</div>
              <div class="dsf-teas-student-class-value">
                {{ nowClassLisst[0].trainingDate }}
              </div>
            </div>
          </div></slot
        >
      </template>
      <template v-if="selectClassLisst.length">
        <slot :info="nowClassLisst[0]">
          <div class="dsf-teas-student-class-sort-title">可选班次</div>
          <div
            v-for="(info, index) in selectClassLisst"
            :key="index"
            class="dsf-teas-student-class-item"
            @click="classItemClick(info)"
          >
            <div class="status">
              <div
                class="type pass"
                v-if="info.statusValue == 2"
              >
                {{ info.statusText }}
              </div>
              <div
                class="type auditing"
                v-else-if="info.statusValue == 1"
              >
                {{ info.statusText }}
              </div>
              <div class="type nopass" v-else>
                {{ info.statusText }}
              </div>
            </div>
            <div class="dsf-teas-student-class-name">
              {{ info.className }}
            </div>
            <div class="dsf-teas-student-class-row">
              <DsfIcon class="dsf-teas-student-class-icon"></DsfIcon>
              <div class="dsf-teas-student-class-label">学号：</div>
              <div class="dsf-teas-student-class-value">
                {{ info.studentSerialNumber }}
              </div>
            </div>
            <div class="dsf-teas-student-class-row">
              <DsfIcon class="dsf-teas-student-class-icon"></DsfIcon>
              <div class="dsf-teas-student-class-label">班主任：</div>
              <div class="dsf-teas-student-class-value">
                {{ info.teacherClasses }}
              </div>
            </div>
            <div class="dsf-teas-student-class-row">
              <DsfIcon class="dsf-teas-student-class-icon"></DsfIcon>
              <div class="dsf-teas-student-class-label">培训日期：</div>
              <div class="dsf-teas-student-class-value">
                {{ info.trainingDate }}
              </div>
            </div>
          </div>
        </slot>
      </template>
    </template>
    <van-empty v-else description="暂无班级数据" />
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfMobileTeasStudentClassList",
  ctrlCaption: "学员班级列表",
  mixins: [$mixins.control],
  design: {
    isMask: false,
  },
  props: {
    url: {
      type: String,
      default: "/mobile/classes/student/findTrainingRecord",
    },
    toUrl: {
      type: String,
      default: "",
    },
  },
  computed: {
    nowClassLisst() {
      let classId = this.isDesign ? "1" : dsf.getCookie("class_id");
      return this.classDataList.filter((info) => info.classId === classId);
    },
    selectClassLisst() {
      let classId = this.isDesign ? "1" : dsf.getCookie("class_id");
      return this.classDataList.filter((info) => info.classId !== classId);
    },
  },
  data() {
    return {
      classDataList: [],
    };
  },
  watch: {
    url() {
      this.getClassList();
    },
  },
  created() {
    this.getClassList();
  },
  methods: {
    getClassList() {
      let { url, isDesign } = this;
      if (isDesign)
        return (this.classDataList = [
          {
            classId: "1",
            className: "班级名称",
            current: "1",
            studentId: "1af960042509460ba3f3a648c36f32fd",
            teacherClasses: "教师名称",
            trainingDate: "时间",
            trainingSite: "文欣101",
          },
          {
            classId: "2",
            className: "班级名称",
            current: "1",
            studentId: "1af960042509460ba3f3a648c36f32fd",
            teacherClasses: "教师名称",
            trainingDate: "时间",
            trainingSite: "文欣101",
          },
          {
            classId: "3",
            className: "班级名称",
            current: "1",
            studentId: "1af960042509460ba3f3a648c36f32fd",
            teacherClasses: "教师名称",
            trainingDate: "时间",
            trainingSite: "文欣101",
          },
        ]);
      if (!url) {
        return;
      }
      this.$http.get(url).then(({ data }) => {
        if (data && data.success) {
          this.classDataList = data.data || [];
        }
      });
    },
    classItemClick(info) {
      if (!info) return;
      if (this.$listeners["itemClick"]) {
        this.$dispatch("itemClick", info);
      } else if (this.toUrl) {
        this.$open({ url: dsf.url.getCookie(this.$replace(this.toUrl, info)) });
      } else if (info.url) {
        this.$open({ url: info.url });
      }
    },
  },
});
</script>
